import { render } from "./App.vue?vue&type=template&id=8f6dd58a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8f6dd58a&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__